// extracted by mini-css-extract-plugin
export var closeButton = "_q1-2";
export var closeButtonIcon = "_q1-3";
export var lightboxContent = "_q1-1";
export var lightboxOverlay = "_q1-0";